// src/composables/useNovelMeta.js
import { ref } from 'vue'
import axios from 'axios'
import config from '@/config'

export function useNovelMeta() {
  // 所有枚举都用 ref，模板内可直接使用
  const types = ref([])
  const languages = ref([])
  const platforms = ref([])
  const lengthTypes = ref([])
  const povs = ref([])
  const styleModes = ref([])
  const eras = ref([])
  const genres = ref([])
  const goldenFingerOptions = ref([]) // [{label,value}]
  const fingerTypes = ref([])
  const titlePatterns = ref([])
  const styles = ref([])
  const femaleRoles = ref([])
  const maleRoles = ref([])
  const villainRoles = ref([])
  const maleJobs = ref([])
  const femaleJobs = ref([])
  const plots = ref([])
  const worlds = ref([])

  async function loadMeta() {
    const { data } = await axios.get(`${config.BASE_URL}/shop/api/novel_meta_api.php`)
    if (data && data.code === 200) {
      const m = data.data || {}
      types.value = m.type || []
      languages.value = m.language || []
      platforms.value = m.platform || []
      lengthTypes.value = m.length_type || []
      povs.value = m.pov || []
      styleModes.value = m.style_mode || []
      eras.value = m.era || []
      genres.value = m.genre || []
      goldenFingerOptions.value = m.golden_finger_options || []
      fingerTypes.value = m.finger_types || []
      titlePatterns.value = m.title_patterns || []
      styles.value = m.styles || []
      femaleRoles.value = m.female_roles || []
      maleRoles.value = m.male_roles || []
      villainRoles.value = m.villain_roles || []
      maleJobs.value = m.male_jobs || []
      femaleJobs.value = m.female_jobs || []
      plots.value = m.plots || []
      worlds.value = m.worlds || []
    }
  }

  // 随机填充工具
  function pick(arr) {
    if (!arr || !arr.length) return ''
    return arr[Math.floor(Math.random() * arr.length)]
  }
  function randomizeForm(form) {
    // 仅在你允许随机时调用
    form.language = pick(languages.value)
    form.platform = pick(platforms.value)
    form.length_type = pick(lengthTypes.value)
    form.pov = pick(povs.value)
    form.style_mode = pick(styleModes.value)
    form.era = pick(eras.value)
    form.genre = pick(genres.value)
    form.style = pick(styles.value)
    form.female_role = pick(femaleRoles.value)
    form.male_role = pick(maleRoles.value)
    form.villain_role = pick(villainRoles.value)
    form.male_job = pick(maleJobs.value)
    form.female_job = pick(femaleJobs.value)
    form.plot = pick(plots.value)
    form.world = pick(worlds.value)
    // 金手指单独处理：根据 options 的 value(0/1)
    const gf = pick(goldenFingerOptions.value)
    form.golden_finger = gf ? gf.value : 0
    form.golden_finger_type = form.golden_finger === 1 ? pick(fingerTypes.value) : ''
    // 你原本固定的默认
    form.title_pattern = pick(titlePatterns.value) || '【情绪事件】+【反差】'
    form.type = pick(types.value) || '女频'
    if (!form.background) form.background = '无'
  }

  return {
    // refs
    types, languages, platforms, lengthTypes, povs, styleModes, eras, genres,
    goldenFingerOptions, fingerTypes, titlePatterns, styles, femaleRoles, maleRoles,
    villainRoles, maleJobs, femaleJobs, plots, worlds,
    // methods
    loadMeta, randomizeForm
  }
}
